import { Text } from '@ui/atoms';
import ToolTip from '@ui/atoms/design-system/tool-tip';
import PropTypes from 'prop-types';

const ToolTipOrText = ({ label, tooltip }) =>
    tooltip ? (
        <ToolTip content={tooltip} placement="bottom-start">
            <Text
                content={label}
                className="text-primary-70 p5-regular whitespace-nowrap"
            />
        </ToolTip>
    ) : (
        <Text
            content={label}
            className="text-primary-70 p5-regular md:p4-regular whitespace-nowrap"
        />
    );

ToolTipOrText.propTypes = {
    label: PropTypes.string.isRequired,
    tooltip: PropTypes.string,
};

export default ToolTipOrText;
